@for (item of dangerRange; track item; let i = $index) {
  <div
    class="text-center"
    [class.selected]="
      item <= value && (dangerRange[i + 1] > value || !dangerRange[i + 1])
    "
  >
    <span>{{ item }} %</span>
    <div
      [style.height.px]="(98 * i) / dangerRange.length + 2"
      [attr.index]="i"
    ></div>
  </div>
}
